module.exports = __webpack_public_path__ + "media/Gif1.f1713e8e.mp4";